import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    width: 300,
  },
});



export default function RangeSlider(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState([props.presentValue[0][1], props.presentValue[1][1]]);

  const handleChange = (event, newValue) => {
      let count=[["min",newValue[0]],["max",newValue[1]]]
      props.changeCount(count)
    setValue(newValue);
 
  };

  return (
    <div className={classes.root}>
      
      <Slider
      style={{color:"white",
    width:"225px"
    }}
        value={value}
        onChange={handleChange}
        max={1000000}
        scale={(x) => x ** 100}
        aria-labelledby="range-slider"
     
      />
    </div>
  );
}




